@import (reference) '../../../../../constants/spacing.module.less';

.section-content {
  padding: @space-8;
}

.section-header {
  align-items: center;
  flex-wrap: nowrap;
}

.refresh-icon {
  width: 14px;
  height: 14px;
}

.document-type-wrapper {
  flex: 1;
}

.document-list {
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: @space-8;
  padding: 0 0 @space-8;
}

.document-list-item {
  align-items: center;
  flex-wrap: nowrap;
  padding: @space-8;
  background: var(--grey-200);
  border: 1px solid var(--grey-300);
  border-radius: 4px;

  &--error {
    border-color: var(--red-300);
    background-color: var(--red-50);
  }
}

.document-info {
  flex: 1;
  min-width: 0;
  align-items: flex-start;
}

.document-type-label {
  color: var(--grey-500);
}

.status-sending {
  align-items: center;
  flex-wrap: nowrap;
  color: var(--grey-500);
  white-space: nowrap;
  flex-shrink: 0;
}

.status-submitted {
  color: var(--green-700);
  white-space: nowrap;
  flex-shrink: 0;
}

// Order-level list items (pre-ship) still use status badges
.status-badge--uploaded,
.status-badge--processing,
.status-badge--processing_claimed,
.status-badge--awaiting_upload {
  color: var(--grey-600);
  white-space: nowrap;
}

.status-badge--failed,
.status-badge--invalid {
  color: var(--red-600);
  white-space: nowrap;
}

.error-message {
  color: var(--red-600);
  margin: 0;
}

.delete-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 18px;
  color: var(--grey-700);

  &:hover {
    color: var(--red-600);
  }
}

.submit-row {
  flex-wrap: nowrap;
  justify-content: flex-end;
}

// ── Starter state (pre-ship initial view) ─────────────────────────────────────

.starter-content {
  align-items: flex-start;
}

.starter-description {
  margin: 0;
  color: var(--grey-600);
}

.info-note {
  margin: 0;
  color: var(--grey-500);
}

// ── Defer upload section ──────────────────────────────────────────────────────

.defer-checkbox-row {
  align-items: center;
  flex-wrap: nowrap;
}

.info-icon {
  color: var(--grey-500);
  cursor: pointer;

  &:hover {
    color: var(--blue-600);
  }
}

.pending-note {
  margin: 0;
  padding-left: @space-24; // align with checkbox label
  color: var(--grey-500);
}
